import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import SectionHeader from '@/components/feature/SectionHeader';

interface TimelineItem {
  year: string;
  title: string;
  desc: string;
}

export default function TimelineSection() {
  const { t } = useTranslation();
  const items = t('about.timeline.items', { returnObjects: true }) as TimelineItem[];

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeader
          eyebrow={t('about.timeline.eyebrow')}
          title={t('about.timeline.title')}
        />

        <div className="relative mt-14">
          <div className="absolute left-[15px] top-2 hidden h-[calc(100%-2rem)] w-px bg-background-300 md:block lg:left-1/2" />
          <ol className="space-y-8 md:space-y-0">
            {items.map((item, index) => {
              const isRight = index % 2 === 1;
              return (
                <Reveal key={item.year} delay={index * 110}>
                  <li className="relative md:grid md:grid-cols-2 md:gap-10">
                    <div className={isRight ? 'md:col-start-2 md:pl-10' : 'md:pr-10 md:text-right'}>
                      <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                        <span className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 font-heading text-sm font-bold text-accent-800">
                          {item.year}
                        </span>
                        <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                      </div>
                    </div>
                    <span className="absolute left-[8px] top-8 hidden h-4 w-4 rounded-full border-2 border-background-100 bg-primary-500 md:block lg:left-1/2 lg:-translate-x-1/2" />
                  </li>
                </Reveal>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}